import { Injectable } from '@angular/core';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import type { DocumentVerifyResultInterface } from '@zaoblako/shared/modules/document/dtos/document-verify/document-verify-result.dto';
import type { DocumentVerifyBodyInterface } from '@zaoblako/shared/modules/document/dtos/document-verify/document-verify-body.dto';
import type { DocumentCompareReportInterface } from '@zaoblako/shared/modules/document/dtos/document-compare/document-compare-report.dto';
import type { DocumentCompareQueryInterface } from '@zaoblako/shared/modules/document/dtos/document-compare/document-compare-query.dto';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DocumentVerifyService extends BaseService {
  protected baseUrl = '/finance/document/verify';

  public synchronize1c(body: DocumentVerifyBodyInterface): Observable<DocumentVerifyResultInterface> {
    return this.http.post<DocumentVerifyResultInterface>(`${this.baseUrl}/synchronize-1c`, body);
  }

  public synchronizeAtrium(body: DocumentVerifyBodyInterface): Observable<null> {
    return this.http.post<null>(`${this.baseUrl}/synchronize-atrium`, body);
  }

  public verifyCompareDocuments(queryParams: DocumentCompareQueryInterface): Observable<DocumentCompareReportInterface> {
    return this.http.get<DocumentCompareReportInterface>(`${this.baseUrl}/compare`, {
      params: this.objectToHttpParams(queryParams)
    });
  }
}
